import { mount } from '../dom-lifecycle';
import { setRecaptchaResponse } from './recaptcha';
import { scrollToFirstError } from './validation';

async function handleAjaxFormSubmit(event) {
	event.preventDefault();
	const form = this;
	
	toggleSubmitButtons(form, false);

	// `setRecaptchaResponse` siedzi WEWNĄTRZ try — wcześniej było przed nim i każdy wyjątek
	// (zablokowany skrypt Google, `grecaptcha` jeszcze niezainicjalizowane) omijał `finally`,
	// zostawiając użytkownika z trwale zablokowanym przyciskiem: bez requestu, bez komunikatu
	// i bez zdarzenia `submit-success`, czyli i bez trackingu. Sama funkcja też już nie rzuca
	// (patrz form/recaptcha.js), ale ten try jest drugą warstwą — obietnicy z tego handlera
	// nikt nie odbiera, więc odrzucenie przechodzi tu w unhandled rejection i ginie po cichu.
	try {
		await setRecaptchaResponse(form);
		var xhr = submitFormData(form);
		var data = await xhr;
	} catch (xhr) {
		return handleSubmitError(form, xhr);
	} finally {
		toggleSubmitButtons(form, true);
	}
	handleSubmitSuccess(form, data, xhr);
}

mount('.ajax-form', form => $(form).on('submit', handleAjaxFormSubmit));

function submitFormData(form) {
	return $.ajax({
		type: 'post',
		url: form.action,
		data: new FormData(form),
		processData: false,
		contentType: false,
		headers: {'X-Requested-With': 'XMLHttpRequest'}
	});
}

function handleSubmitSuccess(form, data, xhr) {
	const successEvent = $.Event('submit-success');
	successEvent.assert = assertResponse;
	$(form).trigger(successEvent, [data, xhr]);
	
	if (successEvent.isDefaultPrevented()) {
		return;
	}
	
	form.reset();
	if (data.redirect) {
		// Krótka zwłoka, żeby beacon Adobe Analytics (`ctaClick` pushowany w js/tracking.js
		// na `submit-success`) wyszedł przed opuszczeniem strony — przy natychmiastowym
		// przekierowaniu na PayU przeglądarka potrafi przerwać żądanie w locie.
		// Na czas zwłoki submit zostaje zablokowany, żeby dublowanie kliknięcia
		// nie wysłało zgłoszenia dwa razy.
		toggleSubmitButtons(form, false);
		setTimeout(() => location.href = data.redirect, 200);
	}
}

function handleSubmitError(form, xhr) {
	const errorEvent = $.Event('submit-error');
	$(form).trigger(errorEvent, xhr);
	
	if (errorEvent.isDefaultPrevented()) {
		return;
	}
	
	if (xhr.responseJSON?.formErrors) {
		processFormErrors(xhr.responseJSON.formErrors, form);
	} else if (xhr.responseJSON?.errors) {
		xhr.responseJSON?.errors.forEach(error => alert(error));
	} else {
		alert("Wystąpił nieznany błąd, spróbuj ponownie później.");
	}
	
	scrollToFirstError(form);
}

function toggleSubmitButtons(form, enabled) {
	$(form.elements).filter('[type=submit]').prop('disabled', !enabled);
}

export function processFormErrors(errors, form) {
	for (const fieldName in errors) {
		if (fieldName === form.name) {
			// Błędy całego formularza, nie pojedynczego pola: captcha („nie udało się potwierdzić,
			// że nie jesteś robotem") i idempotencja („to żądanie zostało już przetworzone").
			// Serwer kluczuje je nazwą formularza, więc nie mają pola, pod którym mogłyby usiąść.
			// Renderujemy je pod przyciskiem wysyłki tym samym komponentem co błędy pól — systemowy
			// `alert()` przy tak długim formularzu bywa przeoczony, a `scrollToFirstError` (poniżej)
			// dowiezie widok do komunikatu, bo szuka `.invalid-feedback`.
			const submitButton = $(form.elements).filter('[type=submit]').last();
			for (const error of errors[fieldName]) {
				if (submitButton.length) {
					submitButton.ajaxInvalidFeedback({ error: escapeHTML(error) });
				} else {
					alert(error);
				}
			}
		} else {
			const field = form.elements[fieldName];
			if (!field) {
				continue;
			}
			// escapeHTML na każdym błędzie osobno: `<br>` ma zostać znacznikiem,
			// ale sama treść błędu (może zawierać wprowadzoną wartość) nie może być HTML-em
			const errorHtml = errors[fieldName].map(error => escapeHTML(error)).join('<br>');
			$(field).ajaxInvalidFeedback({ error: errorHtml });
		}
	}
}

export function assertResponse(condition) {
	if (condition) {
		return;
	}
	const message = 'Nieoczekiwana odpowiedź serwera. Odśwież stronę i spróbuj ponownie.';
	alert(message);
	throw new Error(message);
}